import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    IconButton,
    Box,
    Button,
    Typography,
    DialogContent,
    styled,
    Grid,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PublicRoundedIcon from '@mui/icons-material/PublicRounded';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
const StyledLanguageButton = styled(Button)(({ theme, selected }) => ({
    padding: theme.spacing(2),
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
    // backgroundColor: selected ? theme.palette.primary.main : theme.palette.background.paper,
    color: selected ? "white" : theme.palette.text.primary,
    border: `1px solid ${selected ? theme.palette.primary.main : theme.palette.divider}`,
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
    },
    transition: 'all 0.3s ease'
}));

const FlagContainer = styled(Box)(({ theme }) => ({
    fontSize: '2rem',
    marginBottom: theme.spacing(1),
}));

const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'es', name: 'Spanish', flag: '🇪🇸' },
    // { code: 'ht', name: 'Haitian', flag: '🇭🇹' },
    // { code: 'pt', name: 'Portuguese', flag: '🇵🇹' }
];

function LanguageSelectorDialog() {
    const { t, i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const currentLanguage = i18n.language;

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <>
            <Button
                color="inherit"
                sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
                onClick={() => setOpen(true)}
            >
                <PublicRoundedIcon sx={{ fontSize: { md: "35px", xs: "25px" }, opacity: 0.9 }} />
                <Typography variant="caption" color="inherit">
                    {t('language')}
                </Typography>
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        borderRadius: 2,
                        maxWidth: 'sm',
                        width: '100%',
                        padding: 1
                    }
                }}
            >
                <DialogTitle sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    pb: 2
                }}>
                    <Typography variant="h5" component="div" fontWeight="bold">
                        {t('selectLanguage')}
                    </Typography>
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ mt: 2 }}>
                    <Grid container spacing={2}>
                        {languages.map((language) => (
                            <Grid item xs={12} sm={6} key={language.code}>
                                <StyledLanguageButton
                                    selected={currentLanguage === language.code}
                                    onClick={() => {
                                        i18n.changeLanguage(language.code);
                                        toast.success(t('languageSuccessfullyChanged'));
                                        localStorage.setItem('lang', language.code);
                                    }}
                                >
                                    <FlagContainer>{language.flag}</FlagContainer>
                                    <Typography variant="subtitle1" color={currentLanguage === language.code ? "primary" : "inherit"} fontWeight={currentLanguage === language.code ? 'bold' : 'normal'}>
                                        {language.name}
                                    </Typography>
                                </StyledLanguageButton>
                            </Grid>
                        ))}
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    );
}

export default LanguageSelectorDialog; 